import { Storage, Cachable, CachableType } from '@api/core/storage';

declare global {
    interface Window {
        eshopCache: any;
    }
}

export function Cache () {
    return function (target: Function, propertyKey: string, descriptor: TypedPropertyDescriptor<any>) {
        const compute = descriptor.value;

        if (!window.eshopCache) {
            window.eshopCache = {};
        }

        descriptor.value = async function (...args) {
            const params = [];

            for (const arg of args) {
                if (typeof arg === 'object') {
                    if (arg.length) {
                        let key = '';

                        for (const argComponent of arg) {
                            if (argComponent) {
                                if (argComponent.getCurrentVersion) {
                                    key += argComponent.getCurrentVersion().id + '__';
                                } else if (argComponent.id) {
                                    key += argComponent.id + '__';
                                }
                            }
                        }

                        params.push(key);
                    }

                    if (arg.id) {
                        params.push(arg.id);
                    }
                } else {
                    params.push(arg);
                }
            }

            const endpoint = `${target.prototype.constructor.name}.${propertyKey}(${params.join(',')})`;

            if (window.eshopCache[endpoint]) {
                return window.eshopCache[endpoint];
            }

            // tslint:disable-next-line
            const result = await compute.apply(this, args);
            window.eshopCache[endpoint] = result;

            return result;
        };

        return descriptor;
    };
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/core/cache.ts